// hooks/useBodegaUsuario.js
import { useState } from "react";
import axios from "../configApi/axiosConfig"
import { APIURL } from "../configApi/apiConfig";

const useBodegaUsuario = () => {
  const [data, setData] = useState(null);
  const [vendedor, setVendedor] = useState(null);
  const [analista, setAnalista] = useState(null);
  const [loading, setLoading] = useState(false);  
  const [error, setError] = useState(null);  

 const fetchBodegaUsuario = async (userId, idTipoFactura, fecha, recibeConsignacion,yupana, bodegas = []) => {
  setLoading(true);
  setError(null);
  
  try {
    // Construye el body con los filtros
    const body = {
      userId,
      idTipoFactura,
      fecha,
      recibeConsignacion,
      bodega: bodegas,  // array de bodegas
      yupana: yupana || false // valor de yupana, por defecto false
    };

    //url de la api
    const response = await axios.post(APIURL.getUsuarioBodega(), body);

    setData(response.data);
  } catch (err) {
    console.error(err);
    setError("Hubo un error al obtener los datos.");
  } finally {
    setLoading(false);
  }
};


  const listaVendedoresporBodega = async (fecha, bodega, nivel) => {
    setLoading(true);  
    setError(null);    
    try {
  

      const response = await axios.get(APIURL.listaVendedoresporBodega(fecha, bodega, nivel));

      setVendedor(response.data);
    } catch (err) {
      setError("Hubo un error al obtener los datos.");
    } finally {
      setLoading(false);  
    }
  };

   const listadoAnalista = async () => {
      try {
        const url = APIURL.analistacredito();
        const response = await axios.get(url);
        setAnalista(response.data);
      } catch (err) {
        setError("Hubo un error al obtener los datos.");
      } finally {
        setLoading(false);  
      }
    };

  return {
    data,
    loading,
    error,
    fetchBodegaUsuario,  
    listaVendedoresporBodega,
    vendedor,
    analista,
    listadoAnalista,
  };
};

export default useBodegaUsuario;
